export function api(env) {
  const url = {
    desa: "https://no-prod-api.bancopatagonia.com.ar/qa",
    testing: "https://no-prod-api.bancopatagonia.com.ar/qa",
    prod: "https://api.bancopatagonia.com.ar/pro",
  };

  env = env ? env : "desa";

  return url[env];
}

export function apiKey(env) {
  const url = {
    desa: "6bd6ac93cacf165e542b66eb3482638a",
    testing: "6bd6ac93cacf165e542b66eb3482638a",
    prod: "58c5f3a42d6629003798a8c39a52a507",
  };

  env = env ? env : "desa";

  return url[env];
}
